import { Controller } from "@hotwired/stimulus"

// Boucle de jeu du Défi Cyber : lit les questions embarquées en JSON, gère la
// progression, la révélation et l'écran de fin. Les choix sont mélangés à
// l'affichage (sans biais de position) mais l'index d'origine est conservé pour
// le score. Le serveur recalcule le score à l'enregistrement.
export default class extends Controller {
  static targets = [
    "data", "quiz", "result", "progress", "score", "scenario", "choices",
    "reveal", "punchline", "revealAction", "finalScore", "rank", "actions",
    "answersField"
  ]

  connect() {
    this.questions = JSON.parse(this.dataTarget.textContent)
    this.index = 0
    this.correctCount = 0
    this.answers = []
    this.renderQuestion()
  }

  renderQuestion() {
    const q = this.questions[this.index]
    this.progressTarget.textContent = this.index + 1
    this.scenarioTarget.textContent = q.scenario
    this.revealTarget.classList.add("hidden")
    this.choicesTarget.innerHTML = ""

    const shuffled = this.shuffle(
      q.choices.map((choice, originalIndex) => ({ choice, originalIndex }))
    )

    shuffled.forEach(({ choice, originalIndex }) => {
      const button = document.createElement("button")
      button.type = "button"
      button.textContent = choice
      button.dataset.originalIndex = originalIndex
      button.className =
        "block w-full rounded-lg border border-gray-300 px-4 py-3 text-left hover:border-primary-400 dark:border-gray-700"
      button.addEventListener("click", () => this.answer(originalIndex))
      this.choicesTarget.appendChild(button)
    })
  }

  answer(chosen) {
    const q = this.questions[this.index]
    if (chosen === q.correct) this.correctCount++
    this.answers.push({ id: q.id, chosen: chosen })

    this.scoreTarget.textContent = this.correctCount
    this.punchlineTarget.textContent = q.punchline
    this.revealActionTarget.textContent = "🎯 " + q.action

    Array.from(this.choicesTarget.children).forEach((btn) => {
      const original = Number(btn.dataset.originalIndex)
      btn.disabled = true
      if (original === q.correct) {
        btn.classList.add("border-green-500", "bg-green-50", "dark:bg-green-950")
      } else if (original === chosen) {
        btn.classList.add("border-red-500", "bg-red-50", "dark:bg-red-950")
      }
    })
    this.revealTarget.classList.remove("hidden")
  }

  next() {
    this.index++
    if (this.index < this.questions.length) {
      this.renderQuestion()
    } else {
      this.showResult()
    }
  }

  showResult() {
    this.quizTarget.classList.add("hidden")
    this.finalScoreTarget.textContent = this.correctCount
    this.rankTarget.textContent = this.rankLabel(this.correctCount, this.questions.length)

    // Actions à retenir : priorité aux questions ratées
    const missed = this.answers.filter((a, i) => a.chosen !== this.questions[i].correct)
    const source = missed.length ? missed : this.answers
    this.actionsTarget.innerHTML = ""
    source.forEach((a) => {
      const q = this.questions.find((x) => x.id === a.id)
      const li = document.createElement("li")
      li.textContent = q.action
      this.actionsTarget.appendChild(li)
    })

    this.resultTarget.classList.remove("hidden")
  }

  prepareSubmit() {
    // Renseigne les réponses juste avant l'envoi du formulaire Turbo
    this.answersFieldTarget.value = JSON.stringify(this.answers)
  }

  rankLabel(score, total) {
    const normalized = total === 0 ? 0 : Math.round((score / total) * 10)
    if (normalized <= 4) return "Apprenti·e de l'hygiène"
    if (normalized <= 7) return "Vigilant·e"
    if (normalized <= 9) return "Pro de l'hygiène"
    return "Ceinture noire cyber"
  }

  shuffle(array) {
    const copy = array.slice()
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[copy[i], copy[j]] = [copy[j], copy[i]]
    }
    return copy
  }
}
